import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'
import { GroupFile } from '@/modules/group/modules/groups/domain/models/GroupFile'
import {
  Pagination,
  PaginationRequest
} from '@/modules/shared/schemas/Pagination'

import { axios, Response } from '../index'

type GroupInfoSummaryType = {
  groupId: string
  groupName: string
  groupFiles: GroupFile[]
  category: GroupConfigurationCategory
  groupSendPermission: 'ADMIN' | 'ALL_MEMBERS'
  groupVisibility: 'PUBLIC' | 'PRIVATE'
}

type GroupByIdResponsesType = {
  groupInfoSummary: GroupInfoSummaryType
  firstMembers: []
  totalMembers: number
  loggedPersonaGroupStatus: 'MEMBER' | 'WAITING_REQUEST_APPROVE' | 'NOT_MEMBER'
}

type getPersonaGroupsStatusParam = {
  personaId: string
  filterRequest?: PaginationRequest
}

const getPersonaGroupsStatus = ({
  personaId,
  filterRequest
}: getPersonaGroupsStatusParam): Response<
  Pagination<GroupByIdResponsesType[]>
> => {
  let baseUrl = `/v2/personas/${personaId}/groups/persona-status`

  if (filterRequest) {
    const filterRequestRecordStringAndString =
      filterRequest as unknown as Record<string, string>

    const searchParams = new URLSearchParams()

    for (const [key, value] of Object.entries(
      filterRequestRecordStringAndString
    )) {
      if (value !== undefined && key !== undefined) {
        searchParams.append(key, value.toString())
      }
    }

    baseUrl += `?${searchParams.toString()}`
  }

  return axios.get(baseUrl, {})
}

export default getPersonaGroupsStatus
